import { render, staticRenderFns } from "./imageElement.vue?vue&type=template&id=517faf6a&scoped=true"
import script from "./imageElement.vue?vue&type=script&lang=js"
export * from "./imageElement.vue?vue&type=script&lang=js"
import style0 from "./imageElement.vue?vue&type=style&index=0&id=517faf6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517faf6a",
  null
  
)

export default component.exports